// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"25848490","977":"ab52babb"}[chunkId] + ".chunk.js";
};